const cardData = {
  cards: [
    {
      image: require('../../assets/images/services/itstaff/software-developer.png'),
      title: 'Software Developer',
      desc: 'software_developer_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/testing.png'),
      title: 'Software Tester',
      desc: 'software_tester_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/business-analyst.png'),
      title: 'Business Analyst',
      desc: 'business_analyst_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/web-design.png'),
      title: 'Designer',
      desc: 'designer_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/project-manager.png'),
      title: 'Project Manager',
      desc: 'project_manager_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/devops.png'),
      title: 'Devops',
      desc: 'devops_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/technical-leader.png'),
      title: 'Technical Leader',
      desc: 'technical_leader_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/leader.png'),
      title: 'Team Leader',
      desc: 'team_leader_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/solutions.png'),
      title: 'Solution Architect',
      desc: 'solution_architect_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/jigsaw.png'),
      title: 'Technical Architect',
      desc: 'technical_architect_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/technical-support.png'),
      title: 'IT Support',
      desc: 'it_support_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/data-analysis.png'),
      title: 'Data Analyst',
      desc: 'data_analyst_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/data-scientist.png'),
      title: 'Data Scientist',
      desc: 'data_scientist_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/data-engineer.png'),
      title: 'Data Engineer',
      desc: 'data_engineer_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/avatar.png'),
      title: 'Technical Writer',
      desc: 'technical_writer_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/networking.png'),
      title: 'Network Engineer',
      desc: 'network_engineer_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/network-administrator.png'),
      title: 'Network Administrator',
      desc: 'network_administrator_desc',  // Translation key for description
    },
    {
      image: require('../../assets/images/services/itstaff/internship.png'),
      title: 'Intern',
      desc: 'intern_desc',  // Translation key for description
    }
  ]
};

export default cardData;
